import { render, staticRenderFns } from "./UserInviteTask.vue?vue&type=template&id=5acf2c46&scoped=true"
import script from "./UserInviteTask.vue?vue&type=script&lang=js"
export * from "./UserInviteTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acf2c46",
  null
  
)

export default component.exports